module.exports = __webpack_public_path__ + "static/media/icon_ascend.deb7f8e4.svg";